<template>
  <div class="blockClass">
    <img :src="list.imgSrc" alt="" />
    <div class="result-card-wrap">
      <a-row type="flex" :gutter="16" style="height:100%">
        <a-col
          class="col"
          v-for="colItem in list.tableList"
          :key="colItem.id"
          :span="8"
        >
          <ResultCard :instance="colItem"></ResultCard>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import ResultCard from '@/components/common/ResultCard'
export default {
  props: {
    list: Object
  },
  components: {
    ResultCard
  },
  data() {
    return {}
  }
}
</script>
